var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('ByIcon',{attrs:{"icon":"oops","size":"300"}}),_c('h2',[_vm._v("Oops")]),_c('p',[_vm._v("此頁面已失效")]),_c('p',[_vm._v("開始美好的訂餐體驗吧！")])],1),_c('ByFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }